// SignIn.js
import React from 'react';

const SignIn = () => {
  // The Authenticator component will handle the sign-in process
  return null;
};

export default SignIn;
